import * as z from "zod";

export const getOriginalImageUrl = {
  name: "getOriginalImageUrl" as const,
  input: z.object({
    imageUrl: z.string().regex(/^https?:\/\/.+/, "Must be a valid URL"),
  }),
  output: z.object({
    originalImageUrl: z
      .string()
      .regex(/^https?:\/\/.+/, "Must be a valid URL")
      .nullable(),
  }),
};
